import { ListItem, ListItemAvatar, ListItemText, Badge } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';

import styled from '@emotion/styled';
import { PlayerAvatar } from './PlayerAvatar';
import { PickTeamPlayer } from '../types';

const Wrapper = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isDragging',
})<Partial<GroupPlayerItemProps>>(({ isDragging }) => {
  return {
    paddingRight: 16,
    paddingTop: 4,
    paddingBottom: 4,
    background: isDragging ? '#e6ee9c' : 'inherit',
    ':hover': {
      svg: {
        visibility: 'visible',
      },
      // Add shadow on top and bottom
      boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.1)',
    },
  };
});

type GroupPlayerItemProps = {
  player: PickTeamPlayer;
  dragHandleProps?: any;
  isDragging?: boolean;
  showAppearances?: boolean;
  showStats?: boolean;
};

export default function GroupPlayerItem({
  player,
  dragHandleProps,
  isDragging,
  showAppearances,
  showStats,
}: Readonly<GroupPlayerItemProps>) {
  const colorMaps: Record<number, string> = {
    4: '#0d47a1',
    3: '#1565c0',
    2: '#42a5f5',
    1: '#90caf9',
  };

  return (
    <Wrapper disableGutters isDragging={isDragging} {...dragHandleProps}>
      <DragIndicator
        color={isDragging ? 'primary' : 'disabled'}
        visibility={isDragging ? 'visible' : 'hidden'}
      />
      <ListItem
        sx={{ pl: 0 }}
        secondaryAction={
          <>
            {showAppearances && (
              <Badge
                badgeContent={player.appearances}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor:
                      colorMaps[player.appearances] || colorMaps[1],
                    color: 'white',
                  },
                }}
              />
            )}
            {showStats && (
              <Badge
                badgeContent={`${player.goals}/${player.assists}`}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: '#a1887f',
                    color: 'white',
                  },
                }}
              />
            )}
          </>
        }
      >
        <ListItemAvatar>
          <PlayerAvatar name={player.name} />
        </ListItemAvatar>
        <ListItemText primary={player.name} />
      </ListItem>
    </Wrapper>
  );
}
